import { reactLocalStorage } from 'reactjs-localstorage';
import MyService from '../../service';

const NotifyApi = {
  create: async (data) => {
    let result;

    if (
      !data ||
      !data.noti_title ||
      !data.noti_mess ||
      (data.user_acc_id !== undefined && !data.use_tokn_fireb)
    ) {
      return;
    }

    await MyService.postRequestData('/notify', data)
      .then((data) => (result = data))
      .catch((err) => console.log(err));

    return result;
  },
  getAllNotify: async () => {
    const user = reactLocalStorage.getObject('user.info');
    let result;
    if (user) {
      let noti_topic;
      if (user.user_role_id == 2) {
        noti_topic = 'admin';
      } else if (user.user_role_id == 3) {
        noti_topic = `partner_${user.user_part_id}`;
      }

      await MyService.getRequestData('/notify/get-noti-user', {
        user_acc_id: user.user_acc_id,
        topicNames: noti_topic,
      })
        .then((data) => (result = data))
        .catch((err) => console.log(err));
    }

    return result.code && result.code === 'success' ? result.data : 'null';
  },
  countUnreadNotify: async () => {
    const user = reactLocalStorage.getObject('user.info');
    if (user) {
      let noti_topic;
      if (user.user_role_id === 2) {
        noti_topic = 'admin';
      } else if (user.user_role_id === 3) {
        noti_topic = `partner_${user.user_part_id}`;
      }

      const result = await MyService.getRequestData(
        '/notify/count-unread-noti',
        {
          user_acc_id: user.user_acc_id,
          topicNames: noti_topic,
        }
      );

      return result && result.code && result.code === 'success'
        ? result.data.count
        : null;
    }
  },
  markRead: async () => {
    const user = reactLocalStorage.getObject('user.info');
    if (user) {
      let noti_topic;
      if (user.user_role_id === 2) {
        noti_topic = 'admin';
      } else if (user.user_role_id === 3) {
        noti_topic = `partner_${user.user_part_id}`;
      }

      const result = await MyService.postRequestData('/notify/mark-read', {
        user_acc_id: user.user_acc_id,
        topicNames: noti_topic,
      });

      return result.code === 'success';
    }
  },
};
export default NotifyApi;
